import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  useTheme,
  colors
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const RecentActivitiesModal = ({ 
  open, 
  onClose, 
  activities, 
  onActivityClick 
}) => {
  const theme = useTheme();
  const themeColors = theme.palette.mode === 'dark' 
    ? theme.palette.primary.dark 
    : theme.palette.primary.light;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogTitle sx={{ 
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        fontWeight: 600,
        py: 2
      }}>
        All Recent Activities
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box>
          {activities.map((activity) => (
            <Box
              key={activity.id}
              display="flex"
              alignItems="center"
              p={2}
              borderBottom={`1px solid ${theme.palette.divider}`}
              sx={{ 
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&:last-child': {
                  borderBottom: 'none'
                }
              }}
              onClick={() => {
                onActivityClick(activity);
                onClose();
              }}
            >
              <Box
                sx={{
                  backgroundColor: activity.icon ? theme.palette.primary.main : theme.palette.grey[300],
                  borderRadius: '50%',
                  width: 40,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  color: 'white',
                  flexShrink: 0,
                  boxShadow: theme.shadows[2]
                }}
              >
                {activity.icon || <TrendingUpIcon />}
              </Box>
              <Box flexGrow={1} minWidth={0}>
                <Typography variant="subtitle1" fontWeight={600} noWrap>
                  {activity.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {activity.description}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                  {activity.time}
                </Typography>
              </Box>
              <Box ml={2}>
                <Box 
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 4,
                    backgroundColor: activity.status === 'completed' 
                      ? theme.palette.success.light 
                      : theme.palette.grey[300],
                    color: activity.status === 'completed' 
                      ? theme.palette.success.contrastText 
                      : theme.palette.text.primary,
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'capitalize'
                  }}
                >
                  {activity.status}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button 
          onClick={onClose} 
          variant="contained"
          color="primary"
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            px: 3,
            py: 0.8
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecentActivitiesModal;
